module.exports = __webpack_public_path__ + "img/ar.ee96b96c.svg";